<template>
    <div class="app-card d-flex flex-column justify-content-center align-items-center">
        <div v-if="image"><img alt="Image" :src="image" class="bg-img img-fluid"/></div>
        <div class="app-card-header">
            <slot name="header"></slot>
            <div v-if="title">{{ title }}</div>
        </div>
        <div class="app-card-body">
            <slot></slot>
            <div>{{ body }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["title", "body", "image"]
}

</script>
